import { CustomEventCommand, CustomPlaceCommand } from './hub/custom.event.command';
import { PlaceType } from '../components/hub/place.category/customize.place.category.component';
import { StyleCommand } from './hub/style.command';
import { EditorChoiceDataSource } from '../models/hub/hub.event';

export class PaginationQueryCommand {
  public page? = 1;
  public limit? = 16;
}

export class EventQueryCommand extends PaginationQueryCommand {
  public from?: Date;
  public to?: Date;
}

export class HubBlockQueryCommand {
  public queryParams = {
    page: 1,
    limit: 16,
  };
}

export class HubCalendarQueryCommand {
  public queryParams = {
    category: 'All',
    page: 1,
    limit: 16,
    isApproved: false,
  };
}

export class VisitorCalendarQueryCommand extends EventQueryCommand {
  // public isApproved = true;
  public from?: Date;
  public to?: Date;
  public dateFilterText?: string;
  public category = 'All';
  public categoryList?: string[]; // for custom default place categories
  public search: string;
  public choice: boolean;
  public isCustom: boolean;
  public customEventBtnText?: string;
  public customPlaceBtnText?: string;
  public selectedEvents?: string[];
  public selectedPlaces?: string[];
  public mostAttended: boolean;
  public joinedEventsIds: any;
  public feedId: string;
  public source = 'google';
  public type: string; // for custom fav place btn filter
  public isForMapView?: boolean | undefined = undefined;
}

export class HubCalendarActionCommand {
  // public queryCommand = new HubCalendarQueryCommand();
  public queryParams = {
    category: 'All',
    categoryList: [], // for custom default place categories
    // categoryName: '', // for custom default place categories
    page: 1,
    limit: 16,
    isApproved: true,
    from: null,
    to: null,
    feedId: null,
    search: null,
    noFilter: false,
    isManuallyCreated: false,
    isHubCreated: null,
    isFacebookEvent: null,
    source: 'facebook',
    dmo: null,
    useFuzzyQuery: false,
    searchFields: "name", // 'name', 'address', 'description', 'category',   
  };
  public isEventCalendar = true;
}

export class VisitorCalendarActionCommand {
  public queryCommand = new VisitorCalendarQueryCommand();
  public isEventCalendar = true;
  public isMapView = false;
}

export class VisitorStyleCommand {
  public menuStyle = {
    isSideBar: false,
    menuBarMode: 'normal',
  };
}

export class VisitorTripCommand {
  public item: any;

  constructor(item?: any) {
    this.item = item;
  }
}

export class VisitorTripIdCommand {
  public tripId: string;

  constructor(id?: string) {
    this.tripId = id;
  }
}

export class VisitorSettingsCommand {
  public Style: StyleCommand;
  public menuStyle: {
    isSideBar: boolean;
  };
  public calendarStyle: {
    event: 'default' | 'square' | 'long' | 'modern-block';
    place: 'default' | 'square' | 'long' | 'tile';
  };
  public isHideEditorChoice: boolean;
  public customEditorChoice: EditorChoiceDataSource;
  public placeImagesShownCount: number;
  public dataSource: any;
  public tripPlannerDetailsStyle: string;
  public tripPlannerHomeImage: {
    isDefault: boolean;
    url: string;
  };
  public logo: {
    isDefault: boolean;
    url: string;
  };
  public tourSidebarImage: {
    isDefault: boolean;
    url: string;
  };
  public visitorPromotion: {
    link: string;
    isTop: boolean;
    isDisabled: boolean;
    image: string;
  };
  //public customEvents: CustomEvent[];
  public customEvents: CustomEventCommand[];
  public customPlaces: CustomPlaceCommand[];
  public timezoneFormatter: string;
  public isAllowOnlineEvents: boolean;
  public customDefaultPlaceCategory: CustomDefaultPlaceCategory;
  public isKeepTempClosedPlaceInApproved: boolean;
}

export class CustomEvent {
  public btnText: string;
  public pageFeedId: string;
  public locationFeedId: string;
  public order: number;
  public sourceType: string;
  public isEvent: boolean;
}

export class CustomDefaultPlaceCategory {
  public useDefault: boolean;
  public customCategories: PlaceType[];
}

export class CategoryChangeData {
  public type: string;
  public item: PlaceType;
  public oldTitle: string;
  public newTitle: string;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/commands/pagination.query.command.ts